import React, { useState } from 'react';
import './EmailTagInput.css';

const EmailTagInput = ({ emails, setEmails }) => {
  const [inputValue, setInputValue] = useState('');

  const handleKeyDown = (e) => {
    if ((e.key === 'Enter' || e.key === ',') && inputValue.trim()) {
      e.preventDefault();
      const email = inputValue.trim().replace(/,$/, '');
      if (validateEmail(email) && !emails.includes(email)) {
        setEmails([...emails, email]);
        setInputValue('');
      }
    }
  };

  const removeEmail = (removeEmail) => {
    setEmails(emails.filter((email) => email !== removeEmail));
  };

  const validateEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  return (
    <div className="email-tag-input">
      {emails.map((email) => (
        <div className="tag" key={email}>
          {email}
          <span className="remove" onClick={() => removeEmail(email)}>
            ×
          </span>
        </div>
      ))}
      <input
        type="text"
        placeholder="Type an email and press Enter"
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        onKeyDown={handleKeyDown}
      />
    </div>
  );
};

export default EmailTagInput;
